module.exports = __webpack_public_path__ + "static/media/radio.f67caa61.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/CarEditorPage/components/changeCarData/components/EditCarInformation/img/radio.svg
// module id = 1718
// module chunks = 0